import React from "react";
import { useHref } from "react-router-dom";
import "./headerStyle.css";

const Header = () => {
  const path = useHref();
  if (path === "/") {
    return (
      <header>
        <div className="container">
          <div className="header-content text-center flex flex-column">
            <h1 className="text-uppercase header-title">
              AB web artisans
            </h1>
            <div  className="text-lead">
            <p>
            ?יש לכם עסק? מיזם? סטארטפ
            </p>
            <p>
            בואו לבנות את האתר שלכם,
            שיקח אתכם צעד אחד קדימה
            </p>
            </div>
          </div>
        </div>
      </header>
    );
  }
};

export default Header;
